import React, { useMemo, useState } from 'react';
import TablePagination from '../components/TablePagination';
import { useTablePagination } from '../hooks/useTablePagination';

type MinuteStatus = 'uploading' | 'parsing' | 'ready' | 'failed';
type ShareStatus = 'unshared' | 'shared' | 'expired' | 'stopped';

interface ShareAccessRecord {
  userName: string;
  account: string;
  viewedAt: string;
}

interface MinuteShareAudit {
  status: ShareStatus;
  sharer: string;
  createdAt: string;
  expiresAt: string;
  accessRecords: ShareAccessRecord[];
}

interface MeetingMinute {
  id: string;
  name: string;
  meetingId: string;
  type: string;
  status: MinuteStatus;
  statusText: string;
  creator: string;
  account: string;
  createdAt: string;
  completedAt: string;
  failureReason?: string;
  shareAudit: MinuteShareAudit;
}

const meetingMinutes: MeetingMinute[] = [
  {
    id: 'min-20260225-001',
    name: '宋举登的快速会议',
    meetingId: '12899',
    type: '会议录制',
    status: 'uploading',
    statusText: '上传中',
    creator: '郑婷雅',
    account: 'zhengtingya',
    createdAt: '2026-02-25 18:20:00',
    completedAt: '—',
    shareAudit: {
      status: 'unshared',
      sharer: '—',
      createdAt: '—',
      expiresAt: '—',
      accessRecords: []
    }
  },
  {
    id: 'min-20260225-002',
    name: '2月26日导入',
    meetingId: '—',
    type: '文件导入',
    status: 'parsing',
    statusText: '解析中',
    creator: '冯思钗',
    account: 'fengsichai',
    createdAt: '2026-02-25 18:20:00',
    completedAt: '—',
    shareAudit: {
      status: 'shared',
      sharer: '冯思钗',
      createdAt: '2026-02-26 09:10:00',
      expiresAt: '2026-03-05 23:59:59',
      accessRecords: [
        { userName: '王明', account: 'wangming', viewedAt: '2026-02-26 10:18:24' }
      ]
    }
  },
  {
    id: 'min-20260225-003',
    name: '双周记录',
    meetingId: '837621',
    type: '录音',
    status: 'ready',
    statusText: '成功',
    creator: '李梓发',
    account: 'lizifa',
    createdAt: '2026-02-25 18:20:00',
    completedAt: '2026-02-25 18:27:16',
    shareAudit: {
      status: 'expired',
      sharer: '李梓发',
      createdAt: '2026-02-25 19:00:00',
      expiresAt: '2026-02-28 23:59:59',
      accessRecords: [
        { userName: '赵蕾', account: 'zhaolei', viewedAt: '2026-02-26 11:02:15' },
        { userName: '陈舟', account: 'chenzhou', viewedAt: '2026-03-01 09:30:42' },
        { userName: '林晚', account: 'linwan', viewedAt: '2026-03-01 09:42:10' },
        { userName: '胡宁', account: 'huning', viewedAt: '2026-03-01 10:05:31' },
        { userName: '唐毅', account: 'tangyi', viewedAt: '2026-03-01 10:22:47' },
        { userName: '孙航', account: 'sunhang', viewedAt: '2026-03-01 10:45:18' },
        { userName: '吴清', account: 'wuqing', viewedAt: '2026-03-01 11:03:26' },
        { userName: '马原', account: 'mayuan', viewedAt: '2026-03-01 11:18:40' },
        { userName: '韩霄', account: 'hanxiao', viewedAt: '2026-03-01 11:32:09' },
        { userName: '陆沉', account: 'luchen', viewedAt: '2026-03-01 11:49:53' },
        { userName: '钱宁', account: 'qianning', viewedAt: '2026-03-01 12:06:17' },
        { userName: '何川', account: 'hechuan', viewedAt: '2026-03-01 12:22:35' },
        { userName: '蒋芸', account: 'jiangyun', viewedAt: '2026-03-01 12:40:01' },
        { userName: '徐青', account: 'xuqing', viewedAt: '2026-03-01 13:01:28' },
        { userName: '高越', account: 'gaoyue', viewedAt: '2026-03-01 13:18:46' },
        { userName: '沈禾', account: 'shenhe', viewedAt: '2026-03-01 13:35:12' },
        { userName: '罗真', account: 'luozhen', viewedAt: '2026-03-01 13:52:38' },
        { userName: '梁澈', account: 'liangche', viewedAt: '2026-03-01 14:08:05' },
        { userName: '白雨', account: 'baiyu', viewedAt: '2026-03-01 14:26:19' },
        { userName: '曹然', account: 'caoran', viewedAt: '2026-03-01 14:43:57' },
        { userName: '许诺', account: 'xunuo', viewedAt: '2026-03-01 15:02:33' }
      ]
    }
  },
  {
    id: 'min-20260225-004',
    name: '双周记录',
    meetingId: '837622',
    type: '录音',
    status: 'failed',
    statusText: '失败',
    creator: '周静',
    account: 'zhoujing',
    createdAt: '2026-02-25 18:20:00',
    completedAt: '—',
    failureReason: '音频文件解析失败，请检查文件是否完整后重试。',
    shareAudit: {
      status: 'stopped',
      sharer: '周静',
      createdAt: '2026-02-25 20:16:00',
      expiresAt: '已停止',
      accessRecords: [
        { userName: '周静', account: 'zhoujing', viewedAt: '2026-02-25 20:18:36' }
      ]
    }
  }
];

const statusFilterOptions = [
  { value: 'all', label: '全部状态' },
  { value: 'processing', label: '处理中' },
  { value: 'ready', label: '成功' },
  { value: 'failed', label: '失败' }
];

const searchOptions = ['纪要名称', '会议ID', '创建人', '账号'];

const matchesSearch = (minute: MeetingMinute, field: string, keyword: string) => {
  if (!keyword) {
    return true;
  }

  const normalizedKeyword = keyword.trim().toLowerCase();
  const fieldValueMap: { [key: string]: string } = {
    纪要名称: minute.name,
    会议ID: minute.meetingId,
    创建人: minute.creator,
    账号: minute.account
  };

  return (fieldValueMap[field] || '').toLowerCase().includes(normalizedKeyword);
};

const matchesStatus = (minute: MeetingMinute, statusFilter: string) => {
  if (statusFilter === 'all') {
    return true;
  }
  if (statusFilter === 'processing') {
    return minute.status === 'uploading' || minute.status === 'parsing';
  }
  return minute.status === statusFilter;
};

const getStatusClassName = (status: MinuteStatus) => {
  return `minutes-status minutes-status--${status}`;
};

const shareStatusText: { [key in ShareStatus]: string } = {
  unshared: '未分享',
  shared: '已分享',
  expired: '已到期',
  stopped: '已停止'
};

interface MinutesShareDrawerProps {
  minute: MeetingMinute;
  onClose: () => void;
}

const MinutesShareDrawer: React.FC<MinutesShareDrawerProps> = ({ minute, onClose }) => {
  const {
    total,
    page,
    pageCount,
    pageSize,
    pagedRows,
    setPage,
    setPageSize
  } = useTablePagination(minute.shareAudit.accessRecords, 20);

  const sharerText = minute.shareAudit.status === 'unshared' ? '暂无分享信息' : minute.shareAudit.sharer;

  return (
    <div className="minutes-share-drawer-backdrop" role="presentation" onClick={onClose}>
      <aside className="minutes-share-drawer" aria-label="分享访问记录" onClick={event => event.stopPropagation()}>
        <div className="minutes-share-drawer__header">
          <div>
            <h2>分享访问记录</h2>
            <p>{minute.name}</p>
          </div>
          <button
            type="button"
            className="minutes-share-drawer__close"
            aria-label="关闭分享访问记录"
            onClick={onClose}
          >
            ×
          </button>
        </div>
        <dl className="minutes-share-drawer__meta">
          <div><dt>分享人</dt><dd>{sharerText}</dd></div>
          <div><dt>创建时间</dt><dd>{minute.shareAudit.createdAt}</dd></div>
          <div><dt>有效期</dt><dd>{minute.shareAudit.expiresAt}</dd></div>
          <div><dt>分享状态</dt><dd>{shareStatusText[minute.shareAudit.status]}</dd></div>
        </dl>
        <h3>访问记录</h3>
        <div className="minutes-share-drawer__table">
          <table>
            <thead>
              <tr>
                <th>用户名</th>
                <th>账号</th>
                <th>查看时间</th>
              </tr>
            </thead>
            <tbody>
              {pagedRows.length ? (
                pagedRows.map(record => (
                  <tr key={`${record.account}-${record.viewedAt}`}>
                    <td>{record.userName}</td>
                    <td>{record.account}</td>
                    <td>{record.viewedAt}</td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan={3} className="minutes-share-drawer__empty">暂无访问记录</td></tr>
              )}
            </tbody>
          </table>
        </div>
        {total > 0 ? (
          <TablePagination
            total={total}
            page={page}
            pageCount={pageCount}
            pageSize={pageSize}
            onPageChange={setPage}
            onPageSizeChange={setPageSize}
          />
        ) : null}
      </aside>
    </div>
  );
};

const MeetingMinutes: React.FC = () => {
  const [minutes, setMinutes] = useState(meetingMinutes);
  const [searchField, setSearchField] = useState(searchOptions[0]);
  const [keyword, setKeyword] = useState('');
  const [statusFilter, setStatusFilter] = useState(statusFilterOptions[0].value);
  const [selectedShareMinute, setSelectedShareMinute] = useState<MeetingMinute | null>(null);
  const [isRequirementNoteOpen, setIsRequirementNoteOpen] = useState(false);

  const filteredMinutes = useMemo(
    () => minutes.filter(minute =>
      matchesSearch(minute, searchField, keyword) && matchesStatus(minute, statusFilter)
    ),
    [keyword, minutes, searchField, statusFilter]
  );

  const {
    total,
    page,
    pageCount,
    pageSize,
    pagedRows,
    setPage,
    setPageSize
  } = useTablePagination(filteredMinutes, 20);

  const handleRetry = (minuteId: string) => {
    setMinutes(currentMinutes => currentMinutes.map(minute =>
      minute.id === minuteId
        ? {
            ...minute,
            status: 'parsing',
            statusText: '解析中',
            completedAt: '—',
            failureReason: undefined
          }
        : minute
    ));
  };

  return (
    <div className="page-block">
      <div className="breadcrumb">
        <span>纪要中心</span>
      </div>
      <div className="page-card">
        <div className="toolbar toolbar-bottom">
          <div className="toolbar-left">
            <select
              className="toolbar-select"
              value={searchField}
              onChange={event => setSearchField(event.target.value)}
            >
              {searchOptions.map(option => (
                <option key={option}>{option}</option>
              ))}
            </select>
            <input
              className="toolbar-input"
              placeholder="请输入"
              value={keyword}
              onChange={event => setKeyword(event.target.value)}
            />
            <select
              className="toolbar-select"
              value={statusFilter}
              onChange={event => setStatusFilter(event.target.value)}
            >
              {statusFilterOptions.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
            <button type="button" className="toolbar-icon" aria-label="搜索">
              <span className="icon icon-search" />
            </button>
            <button
              type="button"
              className="toolbar-icon"
              aria-label="刷新"
              onClick={() => {
                setKeyword('');
                setStatusFilter('all');
              }}
            >
              <span className="icon icon-refresh" />
            </button>
          </div>
          <div className="toolbar-right">
            <button
              type="button"
              className="minutes-requirement-toggle"
              aria-expanded={isRequirementNoteOpen}
              onClick={() => setIsRequirementNoteOpen(currentValue => !currentValue)}
            >
              需求说明
            </button>
          </div>
        </div>
        {isRequirementNoteOpen ? (
          <section className="minutes-requirement-note" aria-label="会议纪要分享访问记录需求说明">
            <div className="minutes-requirement-note__header">
              <div>
                <span>需求说明</span>
                <h2>会议纪要分享访问记录</h2>
              </div>
              <time dateTime="2026-06-26">2026-06-26 更新</time>
            </div>
            <ul>
              <li>分享状态包含未分享、已分享、已到期、已停止；已分享使用成功状态绿色。</li>
              <li>所有状态均可点击“查看分享访问记录”；未分享显示空记录，已停止保留历史记录。</li>
              <li>访问记录仅展示用户名、账号和查看时间；纪要列表和抽屉访问记录默认每页 20 条。</li>
            </ul>
          </section>
        ) : null}

        <div className="table-container minutes-table-container">
          <table className="compact-table minutes-table">
            <thead>
              <tr>
                <th>纪要名称</th>
                <th>会议ID</th>
                <th>类型</th>
                <th>任务状态</th>
                <th>创建人</th>
                <th>账号</th>
                <th>创建时间</th>
                <th>完成时间</th>
                <th>分享状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {pagedRows.map(minute => (
                <tr key={minute.id}>
                  <td>{minute.name}</td>
                  <td>{minute.meetingId}</td>
                  <td>{minute.type}</td>
                  <td className="nowrap-cell">
                    <div className="minutes-status-cell">
                      <span className={`${getStatusClassName(minute.status)} ${minute.status === 'uploading' || minute.status === 'parsing' ? 'minutes-status--loading' : ''}`}>
                        {minute.status === 'uploading' || minute.status === 'parsing' ? (
                          <span className="minutes-status__spinner" aria-hidden="true" />
                        ) : null}
                        <span>{minute.statusText}</span>
                        {minute.failureReason ? (
                          <button
                            type="button"
                            className="minutes-status-help"
                            aria-label="查看失败原因"
                            data-reason={minute.failureReason}
                          >
                            ?
                          </button>
                        ) : null}
                      </span>
                      {minute.status === 'failed' ? (
                        <button
                          type="button"
                          className="minutes-table__retry"
                          onClick={() => handleRetry(minute.id)}
                        >
                          重试
                        </button>
                      ) : null}
                    </div>
                  </td>
                  <td>{minute.creator}</td>
                  <td>{minute.account}</td>
                  <td className="nowrap-cell">{minute.createdAt}</td>
                  <td className="nowrap-cell">{minute.completedAt}</td>
                  <td className="nowrap-cell">
                    <span className={`minutes-share-status minutes-share-status--${minute.shareAudit.status}`}>
                      {shareStatusText[minute.shareAudit.status]}
                    </span>
                  </td>
                  <td className="nowrap-cell">
                    <button
                      type="button"
                      className="minutes-table__share"
                      onClick={() => setSelectedShareMinute(minute)}
                    >
                      查看分享访问记录
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <TablePagination
          total={total}
          page={page}
          pageCount={pageCount}
          pageSize={pageSize}
          onPageChange={setPage}
          onPageSizeChange={setPageSize}
        />
      </div>
      {selectedShareMinute ? (
        <MinutesShareDrawer
          key={selectedShareMinute.id}
          minute={selectedShareMinute}
          onClose={() => setSelectedShareMinute(null)}
        />
      ) : null}
    </div>
  );
};

export default MeetingMinutes;
